var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'loader': true, 'hide': !_vm.isLoading},attrs:{"id":"loader"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"circle"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }